import Star from './star';

export * from './star';
export default Star;
